/**
 * Creates or updates an entry in the database
 * @param newData The new or updated data object
 * @returns 
 */
export async function PUT_DATA(newData: Object) {
  try {
    return fetch(encodeURI(`https://kxyac2ee4b.execute-api.us-east-2.amazonaws.com/v1/ddb`),
      {
        method: 'PUT',
        body: JSON.stringify(newData)
      })
      .then(async (response) => {
        return response.json()
      })
  } catch (error) {
    console.error(error);
  }
};

/**
 * Writes or deletes multiple items in the database in one request with the follow array format:
 * [
 *    {PutRequest/DeleteRequest: {Item: data}}, 
 *    {PutRequest/DeleteRequest: {Item: data}}, 
 *    etc
 * ]
 * @param newData The array of new data objects to be written or deleted
 * @returns 
 */
export async function BATCH_MODIFY_DATA(newData: Array<any>) {

  try {
    return fetch(encodeURI(`https://kxyac2ee4b.execute-api.us-east-2.amazonaws.com/v1/ddb`),
      {
        method: 'POST',
        body: JSON.stringify(newData)
      })
      .then(async (response) => {
        return response.json()
      })
  } catch (error) {
    console.error(error);
  }
}

/**
 * Creates or updates a relationship in the #RELATIONSHIPS entry for the user
 * 0 = pending for the target
 * 1 = accepted
 * 2 = blocked for the target
 * 8 = blocked for the initiator
 * 9 = pending for the initiator
 * @param targetRelationship The user who is updating a relationship 
 * @param initiatingRelationship The user who initiated the relationship
 * @param newData The action being performed on the relationship
 * @returns 
 */
export async function UPDATE_RELATIONSHIP(targetRelationship: any, initiatingRelationship: any, updateType: string) {
  var initiatingRel = {
    PK: initiatingRelationship.PK,
    SK: `RELATIONSHIP#${targetRelationship.PK}`,
    status: 0,	// to be changed
    type: 'Relationship',
    relationshipUsername: targetRelationship.relationshipUsername,
    username: initiatingRelationship.username,
    createdAt: new Date().getTime(),
    updatedAt: new Date().getTime(),
  }
  var targetRel = {
    PK: targetRelationship.PK,
    SK: `RELATIONSHIP#${initiatingRelationship.PK}`,
    status: 0,	// to be changed
    type: 'Relationship',
    relationshipUsername: initiatingRelationship.username,
    username: targetRelationship.relationshipUsername,
    createdAt: new Date().getTime(),
    updatedAt: new Date().getTime(),
  }


  try {
    switch (updateType) {
      case "add":
        initiatingRel.status = 9
        targetRel.status = 0
        var putList: { PutRequest: { Item: any; }; }[] = []
        putList.push({ PutRequest: { Item: initiatingRel } })
        putList.push({ PutRequest: { Item: targetRel } })
        await BATCH_MODIFY_DATA(putList)
        break
      case "accept":
        initiatingRel.status = 1
        targetRel.status = 1
        var putList: { PutRequest: { Item: any; }; }[] = []
        putList.push({ PutRequest: { Item: initiatingRel } })
        putList.push({ PutRequest: { Item: targetRel } })
        await BATCH_MODIFY_DATA(putList)
        break
      case "remove":
        var deleteList: { DeleteRequest: { Key: any; }; }[] = []
        deleteList.push({ DeleteRequest: { Key: { PK: initiatingRelationship.PK, SK: `RELATIONSHIP#${targetRelationship.PK}` } } })
        deleteList.push({ DeleteRequest: { Key: { PK: targetRelationship.PK, SK: `RELATIONSHIP#${initiatingRelationship.PK}` } } })
        await BATCH_MODIFY_DATA(deleteList)
        return
      case "block":
        initiatingRel.status = 2
        targetRel.status = 8
        var putList: { PutRequest: { Item: any; }; }[] = []
        putList.push({ PutRequest: { Item: initiatingRel } })
        putList.push({ PutRequest: { Item: targetRel } })
        await BATCH_MODIFY_DATA(putList)
        return
      default:
        console.error("Invalid updateType")
        return
    }
  } catch (error: any) {
    console.error("Error: ", error)
  }
  return
}

/**
 * Creates or updates a trade in the TRADES entry for the user
 * 0 = Pending for the target
 * 1 = Accepted (If both entries are status 1, close the trade)
 * 2 = Rejected (if both entries are status 2, close the trade)
 * 8 = Closed
 * 9 = Pending for the initiator
 * @param targetTrader The user who is being tradeded with (their relationship record)
 * @param initiatingTrader The user who initiated the trade
 * @param tradeContents The contents of the trade.
 * {
 *    pets: [],
 *    items: [],
 *    credits: number
 * }
 * @param updateType The action being performed on the trade
 * @returns 
 */
export async function UPDATE_TRADE(targetTrader: any, initiatingTrader: any, tradeContents: any, updateType: string) {
  var initiatingTrade = {
    PK: initiatingTrader.PK,
    SK: `TRADE#${targetTrader.PK}`,
    status: 0,	// to be changed
    type: 'Trade',
    tradeUsername: targetTrader.tradeUsername,
    tradeContents: tradeContents,
    username: initiatingTrader.username,
    createdAt: new Date().getTime(),
    updatedAt: new Date().getTime(),
  }
  var targetTrade = {
    PK: targetTrader.PK,
    SK: `TRADE#${initiatingTrader.PK}`,
    status: 0,	// to be changed
    type: 'Trade',
    tradeUsername: initiatingTrader.username,
    tradeContents: tradeContents,
    username: targetTrader.tradeUsername,
    createdAt: new Date().getTime(),
    updatedAt: new Date().getTime(),
  }

  try {
    switch (updateType) {
      case "create":
        initiatingTrade.status = 9
        targetTrade.status = 0
        var putList: { PutRequest: { Item: any; }; }[] = []
        putList.push({ PutRequest: { Item: initiatingTrade } })
        putList.push({ PutRequest: { Item: targetTrade } })
        await BATCH_MODIFY_DATA(putList)
        break
      case "accept":
        initiatingTrade.status = 1
        targetTrade.status = 1
        var putList: { PutRequest: { Item: any; }; }[] = []
        var deleteList: { DeleteRequest: { Key: any; }; }[] = []

        // Add the original trades to the put lists with updated statuses first
        putList.push({ PutRequest: { Item: initiatingTrade } })
        putList.push({ PutRequest: { Item: targetTrade } })

        if (tradeContents[0].pets.length > 0) {
          // Format a PutRequest for the batch command
          // Set the PK and owner data correctly
          tradeContents[0].pets.forEach((item: any) => {
            // First, add the original item to the batch delete list.
            // We must use the targetTrader's (AKA the trade creator to the accepting user) 
            // PK as the original PK because this is inside of a for loop
            // where the PK will get overwritten at the end of this push.
            deleteList.push(
              {
                DeleteRequest: {
                  Key: {
                    "PK": targetTrader.PK,
                    "SK": item.SK
                  }
                }
              }
            )
            // Then, edit the item and add it to the batch put list.
            item.PK = initiatingTrader.PK
            item.owner = initiatingTrader.PK
            putList.push({ PutRequest: { Item: item } })
          });
        }

        if (tradeContents[1].items.length > 0) {
          // Format a PutRequest for the batch command
          // Set the PK and owner data correctly
          tradeContents[1].items.forEach((item: any) => {
            // First, add the original item to the batch delete list.
            deleteList.push(
              {
                DeleteRequest: {
                  Key: {
                    "PK": targetTrader.PK,
                    "SK": item.SK
                  }
                }
              }
            )
            // Then, edit the item and add it to the batch put list.
            item.PK = initiatingTrader.PK
            item.owner = initiatingTrader.PK
            putList.push({ PutRequest: { Item: item } })
          });
        }

        if (tradeContents[2].credits > 0) {
          // In this case, the TARGET is the one who STARTED the trade. They're LOSING credits.
          var fullTargetTrader = await GET_BY_USERNAME(targetTrader.tradeUsername, "%23METADATA")

          // In this case, the INITIATOR is the one who's APPROVING the trade. They're GAINING credits.
          // I know, this is all very backwards and I'm confused but it works now.
          var updatedInitiatingTrader = initiatingTrader

          fullTargetTrader!.credits = fullTargetTrader!.credits - tradeContents[2].credits
          updatedInitiatingTrader.credits = updatedInitiatingTrader.credits + tradeContents[2].credits
          putList.push({ PutRequest: { Item: updatedInitiatingTrader } })
          putList.push({ PutRequest: { Item: fullTargetTrader } })

          // Update everything that was added to both lists.
          await BATCH_MODIFY_DATA(putList)
          await BATCH_MODIFY_DATA(deleteList)
        }
        break
      case "reject":
        initiatingTrade.status = 2
        targetTrade.status = 2
        var putList: { PutRequest: { Item: any; }; }[] = []
        putList.push({ PutRequest: { Item: initiatingTrade } })
        putList.push({ PutRequest: { Item: targetTrade } })
        await BATCH_MODIFY_DATA(putList)
        break
      case "close":
        initiatingTrade.status = 8
        targetTrade.status = 8
        var putList: { PutRequest: { Item: any; }; }[] = []
        putList.push({ PutRequest: { Item: initiatingTrade } })
        putList.push({ PutRequest: { Item: targetTrade } })
        await BATCH_MODIFY_DATA(putList)
        break
      case "remove":
        var deleteList: { DeleteRequest: { Key: any; }; }[] = []
        deleteList.push({ DeleteRequest: { Key: { PK: initiatingTrader.PK, SK: `TRADE#${targetTrader.PK}` } } })
        deleteList.push({ DeleteRequest: { Key: { PK: targetTrader.PK, SK: `TRADE#${initiatingTrader.PK}` } } })
        await BATCH_MODIFY_DATA(deleteList)
        return
      default:
        console.error("Invalid updateType")
        return
    }
  } catch (error: any) {
    console.error("Error: ", error)
  }
  return
}


/**
 * Deletes an entry in the database
 * @param deletedData The data to be deleted.
 * @returns 
 */
export async function DELETE_DATA(deletedData: Object) {
  try {
    return fetch(encodeURI(`https://kxyac2ee4b.execute-api.us-east-2.amazonaws.com/v1/ddb`),
      {
        method: 'DELETE',
        body: JSON.stringify(deletedData)
      })
      .then(async (response) => {
        return response.json()
      })
  } catch (error) {
    console.error(error);
  }
};

/**
 * Remember that the KeyConditionExpression is CASE SENSITIVE. Lowercase "PK"/"SK" will not work.
 * @param pk Primary Key (the userID)
 * @param sk Sort Key (the item type)
 * @returns 
 */
export async function GET_BY_PK_SK(pk: string, sk: string) {
  // The pound symbol needs to be encoded in order to get through the API Gateway...
  // Then it's replaced again within the lambda function because that works somehow.
  sk == "#METADATA" ? sk = "%23METADATA" : sk = sk
  const encodedURI = encodeURI(`https://kxyac2ee4b.execute-api.us-east-2.amazonaws.com/v1/ddb?PK=${pk}&SK=${sk}`)
  try {
    return fetch(encodedURI,
      {
        method: 'GET',
      })
      .then(async (response) => {
        return response.json()
      })
  } catch (error) {
    console.error(error);
  }
}

/**
 * Remember that the KeyConditionExpression is CASE SENSITIVE. Lowercase "PK"/"SK" will not work.
 * @param un Primary Key (the username)
 * @returns 
 */
export async function GET_BY_USERNAME(un: string, sk?: string) {
  try {
    return fetch(`https://kxyac2ee4b.execute-api.us-east-2.amazonaws.com/v1/ddb?username=${un}&SK=${sk}`,
      {
        method: 'GET',
      })
      .then(async (response) => {
        return response.json()
      })
  } catch (error) {
    console.error(error);
  }
}

/**
 * Remember that the KeyConditionExpression is CASE SENSITIVE. Lowercase "PK"/"SK" will not work.
 * @param pk Primary Key (the userID)
 * @param sk Sort Key (the item type)
 * @returns 
 */
export async function LIST_SELLING_BY_PK(pk: string) {
  try {
    return fetch(encodeURI(`https://kxyac2ee4b.execute-api.us-east-2.amazonaws.com/v1/ddb?PK=${pk}&selling`),
      {
        method: 'GET',
      })
      .then(async (response) => {
        return response.json()
      })
  } catch (error) {
    console.error(error);
  }
}